// Query keys for cache management — imported by senderApi2.ts
export const senderKeys = {
  all: ['sender'] as const,
  // Collections - use these for invalidating all items of a type
  alltravellers: ['sender', 'travellers'] as const,
  allCheckItems: ['sender', 'checkItems'] as const,
  allMyItems: ['sender', 'myItems'] as const,
  allMyOrders: ['sender', 'myOrders'] as const,
  allMyOrderDetails: ['sender', 'myOrderDetails'] as const,
  // Individual entities - use these for specific queries
  travellers: ['sender', 'travellers'] as const,
  travellersList: (params: object) => [...senderKeys.travellers, params] as const,
  checkItems: (userId: number) => ['sender', 'checkItems', userId] as const,
  favorites: (userId: number) => ['sender', 'favorites', userId] as const,
  myItems: (userId: number) => ['sender', 'myItems', userId] as const,
  myOrders: (senderId: number) => ['sender', 'myOrders', senderId] as const,
  myOrderDetails: (senderId: number, orderId: number) => ['sender', 'myOrderDetails', senderId, orderId] as const,
  cancellationPolicies: ['sender', 'cancellationPolicies'] as const,
  ratings: (senderId: number) => ['sender', 'ratings', senderId] as const,
  trackOrder: (orderId: number) => ['sender', 'trackOrder', orderId] as const,
  myOrderDetail: (senderId: number, orderId: number) => ['sender', 'myOrderDetail', senderId, orderId] as const,
};
